import React, { useState } from 'react';
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
  closestCenter,
} from '@dnd-kit/core';
import CrmPipelineColumn from './CrmPipelineColumn';
import CrmPipelineCard from './CrmPipelineCard';

const CrmPipeline = ({ prospectos, etapas = [], onEtapaChange, onSelect, selectedId, onToggleView, onGestionarEtapas }) => {
  const [activeProspecto, setActiveProspecto] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } })
  );

  const handleDragStart = ({ active }) => {
    setActiveProspecto(prospectos.find(p => String(p.id) === active.id) || null);
  };

  const handleDragEnd = ({ active, over }) => {
    setActiveProspecto(null);
    if (!over) return;
    const prospectoId = parseInt(active.id);
    const newEtapa = over.id;
    const prospecto = prospectos.find(p => p.id === prospectoId);
    if (prospecto && newEtapa !== prospecto.etapa && etapas.some(e => e.nombre === newEtapa)) {
      onEtapaChange(prospectoId, newEtapa, prospecto.etapa);
    }
  };

  const handleDragCancel = () => setActiveProspecto(null);

  const columns = etapas.map(e => ({
    value: e.nombre,
    label: e.nombre,
    color: e.color,
    // Comparación case-insensitive: prospectos viejos (de antes de crm_etapas, migración
    // 014) tienen etapa en minúscula ('nuevo'), mientras que las etapas configurables
    // usan nombres capitalizados ('Nuevo') — con match exacto esos prospectos no
    // aparecían en ninguna columna del pipeline.
    items: prospectos.filter(p => (p.etapa || '').toLowerCase() === e.nombre.toLowerCase()),
  }));

  const totalProspectos = prospectos.filter(p => !p.es_cliente).length;
  const totalClientes = prospectos.filter(p => p.es_cliente).length;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#f9fafb' }}>

      {/* Header */}
      <div style={{
        padding: '0.875rem 1.5rem',
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexShrink: 0,
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: '#111827' }}>
            📋 Pipeline comercial
          </h2>
          <p style={{ margin: 0, fontSize: '0.72rem', color: '#9ca3af', marginTop: '0.1rem' }}>
            {totalProspectos} prospecto{totalProspectos !== 1 ? 's' : ''} · {totalClientes} cliente{totalClientes !== 1 ? 's' : ''} · Arrastra las tarjetas para cambiar etapa
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button onClick={onGestionarEtapas} style={{
            background: '#f3f4f6', color: '#374151',
            border: '1.5px solid #e5e7eb', borderRadius: '8px',
            padding: '0.4rem 0.9rem', cursor: 'pointer',
            fontSize: '0.82rem', fontWeight: '600',
            display: 'flex', alignItems: 'center', gap: '0.35rem',
          }}>
            ⚙️ Etapas
          </button>
          <button onClick={onToggleView} style={{
            background: '#eff6ff', color: '#2563eb',
            border: '1.5px solid #bfdbfe', borderRadius: '8px',
            padding: '0.4rem 0.9rem', cursor: 'pointer',
            fontSize: '0.82rem', fontWeight: '600',
            display: 'flex', alignItems: 'center', gap: '0.35rem',
          }}>
            💬 Vista chat
          </button>
        </div>
      </div>

      {/* Kanban */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onDragCancel={handleDragCancel}
      >
        <div style={{
          flex: 1, display: 'flex', gap: '0.875rem',
          padding: '1rem 1.5rem',
          overflowX: 'auto', overflowY: 'hidden',
          alignItems: 'flex-start',
        }}>
          {columns.map(col => (
            <CrmPipelineColumn
              key={col.value}
              etapa={col}
              items={col.items}
              onSelect={(id) => { onSelect(id); onToggleView(); }}
              selectedId={selectedId}
            />
          ))}
        </div>

        <DragOverlay dropAnimation={null}>
          {activeProspecto && (
            <div style={{ width: '230px' }}>
              <CrmPipelineCard prospecto={activeProspecto} onSelect={() => {}} isSelected={false} isDragOverlay />
            </div>
          )}
        </DragOverlay>
      </DndContext>
    </div>
  );
};

export default CrmPipeline;
